import closeIcon from '@/assets/svg/closeIcon.svg'
import clsx from 'clsx'
import Link from 'next/link'

import { MapMarker } from '@/widgets/ShopsMapNew/assets/MapMarker'
import { MapService } from '@/widgets/ShopsMapNew/assets/MapService'
import { Shop } from '@/widgets/ShopsMapNew/types/shop'

import { Icon } from '@/shared/ui/icon'

import cls from './MapBalloon.module.scss'

type BalloonProps = {
	shop: Shop
	isVisible?: boolean
	fastOrderLink?: string
}

export const MapBalloon = ({ shop, isVisible }: BalloonProps): JSX.Element => {
	const isDesktop = typeof window !== 'undefined' && window.matchMedia('(min-width: 992px)').matches
	const { NAME, METRO_LINE, METRO, FULL_ADDRESS, SCHEDULE, STORE_ID, UF_IS_SERVICE } = shop

	return !isDesktop ? (
		<div className={clsx(cls.mapBalloon, isVisible && cls.mapBalloon_visible)}>
			<Icon icon={closeIcon} height={14} width={14} className={cls.mapBalloon__closeIcon} />
			<p className={cls.mapBalloon__title}>{NAME}</p>
			<div className={cls.mapBalloon__subwayPanel}>
				<span style={{ background: METRO_LINE }} className={cls.mapBalloon__subwayMark} aria-hidden="true" />
				<span className={cls.mapBalloon__subwayName}>{METRO}</span>
			</div>
			<p className={cls.mapBalloon__address}>{FULL_ADDRESS}</p>
			<p className={cls.mapBalloon__sheldue}>{SCHEDULE}</p>

			<Link prefetch={false} href={`/shops/${STORE_ID}`} className={cls.mapBalloon__button}>
				Подробнее
			</Link>

			{UF_IS_SERVICE === '1' ? (
				<MapService color="#568DFE" className={cls.mapBalloon__markerService} />
			) : (
				<MapMarker color="#568DFE" className={cls.mapBalloon__marker} />
			)}
		</div>
	) : (
		<></>
	)
}
